import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { learnApi } from '@/api/endpoints';
import type { ApiProblemTopic, LearnPostSummary } from '@/api/types';
import { LEARN_INDEX_PATH } from '@/lib/structuredData';
import { useInitialData } from '@/ssr/initialData';
import { LearnPostCard } from './LearnPostCard';

const LIMIT = 6;

/**
 * Mavzu sahifasidagi (/topics/:topic) "Shu mavzu bo'yicha darsliklar" — ichki havolalar.
 * Prerender ma'lumoti bo'lsa shundan (hydration mos), aks holda API dan. Post yo'q — blok yo'q.
 */
export function TopicLearnPosts({ topic, path }: { topic: ApiProblemTopic; path: string }) {
  const { t } = useTranslation();
  const initial = useInitialData();
  const [posts, setPosts] = useState<LearnPostSummary[] | null>(
    initial?.path === path && initial.learnPosts ? initial.learnPosts : null,
  );

  useEffect(() => {
    if (posts !== null) return;
    let cancelled = false;
    learnApi
      .list(topic)
      .then((res) => {
        if (!cancelled) setPosts(res.data);
      })
      .catch(() => {
        /* ixtiyoriy blok — xato bo'lsa ko'rsatilmaydi */
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topic]);

  if (!posts || posts.length === 0) return null;

  return (
    <section className="mt-12">
      <div className="mb-4 flex items-baseline justify-between gap-4">
        <h2 className="text-lg font-semibold">{t('learn.topicBlockTitle')}</h2>
        <Link to={LEARN_INDEX_PATH} className="text-sm font-medium text-brand-600 hover:underline">
          {t('learn.allPosts')} →
        </Link>
      </div>
      <ul className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {posts.slice(0, LIMIT).map((p) => (
          <li key={p.slug}>
            <LearnPostCard post={p} />
          </li>
        ))}
      </ul>
    </section>
  );
}
